<template>
  <div>


        <Header
        :BackPage='true'
        :HideCart='false'
        Title='Meu carrinho'
        />


      <Loader
      :isLoading='this.load'
      />
      <MainContainer
      class='mainContainer'
       >

      
        <div class='productContainer'>
             <router-link to='home' class="addMoreProducts">Adicionar mais produtos</router-link>
            <ProductItem
            v-show='cartObj'
            :ProductObject='cartObj'
            :alterQuantity='addToCart'
            :removeToCart='removeToCart'
            />

         

        </div>


             <div class='card form-group'>
                <p to='home' class="addMoreProducts">Finalize seu pedido</p>
                <select class='form-control form-select mt-2' v-model='checkout.payment'   >
                      <option value="inital" selected disabled hidden>Forma de pagamento</option>

                      <option v-for="option in paymentList" :key='option.id' :value="option.id">
                          {{ option.name }}
                      </option>
              
                </select>
                
                <select class='form-control form-select mt-3' v-model='checkout.delivery'  >
                    <option value="inital" selected disabled hidden>Forma de entrega</option>
                      <option v-for="option in deliveryList" :key='option.id' :value="option.id">
                          {{ option.name }}
                      </option>
              
                </select>
            </div>

          <div class="card-body card p-2">
            <div class='summaryRow'>
                <div >Seu crédito</div>
                <div class="font-weight-bold text-dark" >R$ {{formartPrice(this.credito)}}</div>
            </div>
            <div class='summaryRow'>
                <div >{{pre_cart_total}} produtos</div>
                <div class="font-weight-bold text-dark" >R$ {{formartPrice(this.pre_cart_itens)}}</div>
            </div>
            <div class='summaryRow'>
                <div class='summaryDiv'>Total</div>
                <div class="font-weight-bold text-dark">R$ {{formartPrice(this.total_liquido)}}</div>
            </div>
            <br>
            <small>* Entregas em domicilio valor minimo de R$100,00</small>
            <small>* FRETE GRATIS ACIMA DE R$150,00</small>
          </div> <!-- card-body.// -->  
        {{this.checkout.payment.id}}
        {{this.checkout.delivery.id}}
        <Button
        v-show='checkout.payment != "inital" && checkout.delivery != "inital"'
        id='first_button'
        Type='submit'
        Text='FINALIZAR PEDIDO'
        :ButtonFunction='finishSale'
        />


     </MainContainer>  










  </div> 
</template>

<script>
import Header from '../../components/Header/Header'
import Button from '../../components/Button/ButtonCallToAction'
//import ButtonOutline from '../../components/Button/ButtonCallToActionOutline'
import ProductItem from '../../components/Product/ProductItemCart'
import MainContainer from '../../components/Container/MainContainer'
import {mapState, mapActions} from 'vuex'
import Loader from '../../components/Load/LoadOverlay'
import {formatPrice} from '../../tools/formatPrice'


export default {
  components: {
    Header,
    Button,
    //ButtonOutline,
    ProductItem,
    MainContainer,
    Loader,

  },
  data() {
    return {
      products: {},
      load:false,
      credito:0,
      deliveryList:[
    {
      "id": 2,
      "name": "Entrega em domicilio",
      "tempo_entrega": 10
    },
    {
      "id": 3,
      "name": "Buscar na loja hoje até as 18 horas",
      "tempo_entrega": 1
    },
    {
      "id": 1,
      "name": "Buscar na loja amanhã de manhã",
      "tempo_entrega": 0
    },
    {
      "id": 4,
      "name": "Buscar na loja amanhã de tarde",
      "tempo_entrega": 1
    }
  ],
      paymentList:[
    {
      "id": 1,
      "name": "Pix",
      "img": null
    },
    {
      "id": 2,
      "name": "Dinheiro",
      "img": null
    },
    {
      "id": 3,
      "name": "Cartão de débito",
      "img": null
    },
    {
      "id": 4,
      "name": "Cartão de crédito",
      "img": null
    }
  ],
      checkout:{

        status: 1,
        payment: 'inital',
        delivery: 'inital',
        desconto:1,
        total: "0",
        finish: false,
        obs: "teste",
        user: 0
    }
    }
  },
  computed: {
      
        ...mapState('pre_cart',['cart','pre_cart_total','pre_cart_itens']),
        ...mapState('home',['credit']),
        ...mapState('auth',['user']),
        ...mapState('cart_checkout',['payment,delivery']),
        total_liquido (){
          return this.pre_cart_itens - this.credit
        },
        userLocalId (){
          return localStorage.getItem('id_user');
        },
        cartObj (){
          return this.cart;
        },

  },
  methods: {
    ...mapActions('home',['ActionGetCredito']),
    ...mapActions('product_detail',['ActionAddProductToCart']),
    ...mapActions('pre_cart',['ActionGetCartComplete','ActionDeleteCartComplete','ActionGetPreCart']),
    ...mapActions('cart_checkout',['ActionFinishSale','ActionDeleteProduct','ActionGetPayment', 'ActionGetDelivery']),
    async finishSale() {
      this.checkout.user = this.userLocalId
      this.load = !this.load
      this.checkout.desconto = 0
      const finish = await this.ActionFinishSale(this.checkout)
      this.ActionDeleteCartComplete()
      if(finish === 201){
        this.load = !this.load
        this.$router.push({name:'finish_order'})
      }
      if (finish == 400){
        alert('Erro ao finilizar pedido.')
        this.load = !this.load
        location.reload()
      }
    },
    formartPrice(price){
        return formatPrice(price)
    },
    async addToCart (obj){
            this.load = !this.load
            const addProductUnit =  await this.ActionAddProductToCart(obj)
            if (addProductUnit === 'OK') {
                this.ActionGetPreCart({user:this.userLocalId})
                this.ActionGetCartComplete({id:this.userLocalId})
                this.load = !this.load
            }
            if (addProductUnit === 'ERROR') {
                alert('Erro ao adicionar produto.')
                location.reload()
            }

    },  
    async removeToCart (obj){
            const confirmDelete = confirm('Deseja remover item do carrinho? ')
            if (confirmDelete) {
                this.load = !this.load
                const removeProduct =  await this.ActionDeleteProduct(obj)
                if (removeProduct === 204) {
                    this.ActionGetCartComplete({id:this.userLocalId})
                    this.ActionGetPreCart({user:this.userLocalId})
                    location.reload()
                    this.load = !this.load
                }
                if (removeProduct === 'ERROR') {
                    alert('Erro ao remover produto.')
                    this.load = !this.load
                    location.reload();
                }
            }
    },  
    setEntrega(e) {
        this.checkout.delivery = e
    },
    setPagamento(e) {
        this.checkout.payment = e
    },
    isEmpty(obj) {
    return Object.keys(obj).length === 0;
}

  },
  async created () {
    this.load = !this.load
    this.ActionGetPreCart({user:this.userLocalId})
    await this.ActionGetCartComplete({id:this.userLocalId})
    if (this.cart == 0){
      this.$router.push({name:'pre_cart'})
    }
    else{
      this.product = this.cart
      this.load = !this.load
    }
  },
      mounted() {
  
  }
}
</script>

<style scoped lang="css">
@import '../../assets/css/mobile.css';

div[data-v-046fd69a] {
    padding: 0.2rem 0;
    text-transform: uppercase;
}

.summaryRow {
    display: flex;
    color: rgb(153, 153, 153);
    -webkit-box-pack: justify;
    justify-content: space-between;

}


.addMoreProducts {
    font-size: 14px;
    line-height: 20px;
    color: var(--main-red-black);
    margin-top: 16px;
    margin-bottom: 16px;
    text-align: center;
    cursor: pointer;
}


.Spacer{
  height: 5.625rem;
}

.productContainer{
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left:1%;
  margin-right:1%;
}

.mainContainer{
  position:absolute; 
  top:1.3rem; 
  bottom:1rem; 
  left:0px; 
  right:0px; 
  overflow:auto;
  
}

.footer{
  position:absolute; 
  bottom:0px; 
  height:200px; 
  left:0px; 
  right:0px; 
  overflow:hidden
}

.titleh1{
  display: flex;
  align-items: center;
  text-align: center;
}

.inputWhatsapp{
  margin-top:7.25rem;
}

#first_button{
  margin-bottom:.5rem;
}
  .main{
    display:block;
    width:100%;    
    margin-left:auto;
    margin-right:auto;  
}

.form-control-lg {
    height: calc(1.5em + 1.2rem + 2px);
    padding: 0.6rem 1rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.55rem;
}

  @media (min-width: 1400px) and (max-width: 2600px) {
  .main{
    display:block;
    width:70%;    
    margin-left:auto;
    margin-right:auto;  
}
  }
</style>
